export default {
  'menu.welcome': '欢迎',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.login': '登录',
  'menu.register': '注册',
  'menu.register-result': '注册结果',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.settings': '个人设置',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
  'menu.cloud-server': '云服管理',
  'menu.cloud-server.categories': '游戏分类',
  'menu.cloud-server.types': '游戏类型',
  'menu.cloud-server.nodes': '游戏节点',
  'menu.cloud-server.plans': '游戏套餐',
  'menu.cloud-server.servers': '云服列表',
  'menu.cloud-server.servers-create': '创建云服',
  'menu.cloud-server.tutorials': '游戏教程',
  'menu.cloud-server.tutorials-edit': '编辑教程',
  'menu.game': '游戏管理',
  'menu.game.minecraft-modpacks': '整合包广场',
  'menu.game.mod-market': '游戏模组广场',
  'menu.chat': '聊天管理',
  'menu.chat.world-chat': '世界聊天',
  'menu.cdk': 'CDK 管理',
  'menu.cdk.types': 'CDK 类型',
  'menu.cdk.list': 'CDK 列表',
  'menu.cdk.create': 'CDK 创建',
  'menu.activity': '活动管理',
  'menu.activity.control': '活动控制',
  'menu.announcement': '公告管理',
  'menu.user': '用户管理',
  'menu.user.list': '用户列表',
  'menu.system': '系统管理',
  'menu.system.settings': '基础设置',
  'menu.system.payment': '支付设置',
  'menu.system.admins': '管理员列表',
  'menu.system.oss': 'OSS 配置',
  'menu.system.schedule-settings': '计划设置',
};
